import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, catchError, withLatestFrom } from 'rxjs/operators';
import * as fromLocalAuthoritiesActions from '../actions/local-authorities.actions';
import * as fromStore from '../';
import * as fromLa from '@modules/local-authorities/services';
import { Store } from '@ngrx/store';
import { AppState } from '@app/store/state';
import { LocalAuthority } from '@modules/local-authorities/interfaces';

@Injectable()
export class LocalAuthorityEffects {
    constructor(
        private readonly actions$: Actions,
        private readonly store: Store<AppState>,
        private readonly service: fromLa.LocalAuthoritiesService
    ) {}

    loadLocalAuthorities$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(fromLocalAuthoritiesActions.LoadLocalAuthorities),
            withLatestFrom(this.store.select(fromStore.selectListOfSelectedLocalAuthorities)),
            switchMap(([_, selectedLocalAuthorities]) => {
                return this.service.getLocalAuthorities(selectedLocalAuthorities).pipe(
                    map((localAuthorities: LocalAuthority[]) => ({
                        type: fromLocalAuthoritiesActions.LOAD_LOCAL_AUTHORITIES_SUCCESS,
                        payload: localAuthorities
                    })),
                    catchError((error) => of(fromLocalAuthoritiesActions.LoadLocalAuthoritiesFail(error)))
                );
            })
        );
    });
}
